export const locale___App = {

	'button___back': {
		de_de: 'stornieren',
		en_us: 'cancel',
		es_es: 'cancelar',
		fr_fr: 'annuler',
		it_it: 'annulla',
	},

	'button___close': {
		de_de: 'schließen',
		en_us: 'close',
		es_es: 'cerrar',
		fr_fr: 'fermer',
		it_it: 'chiudi'
	},

	'____________________________': {
		de_de: '____________________________',
		en_us: '____________________________',
		es_es: '____________________________',
		fr_fr: '____________________________',
		it_it: '____________________________',
	},

};